export type AddressType = 'chargement' | 'livraison';
export type AddressStatus = 'complet' | 'a_completer';
export type AddressAnalysisStatus = 'modification_en_cours_analyse' | 'validated' | null;

export interface CustomerAddressNotice {
  code: 'ADDRESS_CHANGE_UNDER_REVIEW';
  message: string;
}

export interface CustomerAddressData {
  street: string | null;
  postal: string | null;
  city: string | null;
  country: string | null;
  type_logement: string | null;
  type_logement_code?: string | null;
  surface: number | null;
  floor: string | null;
  lift: boolean | null;
  lift_comment: string | null;
  all_in_lift: number | null;
  all_in_lift_comment?: string | null;
  stairs: number | null;
  stairs_comment?: string | null;
  cave: boolean | number | null;
  cave_comment: string | null;
  mm_conseille: number | null;
  mm_obligatoire?: number | null;
  mm_utilisable?: number | null;
  mm_comment?: string | null;
  observations?: string | null;
  stationnement?: CustomerAddressStationnement | null;
}

export interface CustomerAddress {
  id: number;
  order: number;
  type: AddressType;
  status: AddressStatus;
  analysis_status: AddressAnalysisStatus;
  label: string;
  notice: CustomerAddressNotice | null;
  data: CustomerAddressData;
}

export interface CustomerAddressesByType {
  chargement: CustomerAddress[];
  livraison: CustomerAddress[];
}

export const emptyAddressesByType = (): CustomerAddressesByType => ({
  chargement: [],
  livraison: [],
});

export interface AddressesState {
  addresses: CustomerAddressesByType;
  addressesLoading: boolean;
  addressSaving: boolean;
}

export interface CustomerAddressStationnement {
  type?: string | null;
  portage?: string | null;
  transbo_dist?: number | null;
}

export interface CustomerAddressPayload extends CustomerAddressData {
  stationnement?: CustomerAddressStationnement | null;
}

export function findAddressById(
  addresses: CustomerAddressesByType,
  id: number,
): CustomerAddress | null {
  return (
    addresses.chargement.find((address) => address.id === id)
    || addresses.livraison.find((address) => address.id === id)
    || null
  );
}
